import React, {Component} from 'react';
import ContentPanel from "../../components/ContentPanel/ContentPanel";
import Skeleton from "../../components/Skeleton/Skeleton";
import ContentAccordion from "../../components/ContentAccordion/ContentAccordion";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';

import ToolsWidget from "../../components/ToolsWidget/ToolsWidget";


class FAQ extends Component{
    constructor(props) {
        super(props);
        this.contentAcc = React.createRef();
        this.setRef = this.setRef.bind(this);
    }

    setRef(input) {
        //this will scroll to the selected category from the FAQ button on the Contact page
        let selectedDomElement = input
        if(selectedDomElement){
            selectedDomElement.focus()
            selectedDomElement.scrollIntoView()
        }
    }

    componentDidMount() {
        this.setRef();
    }
    componentDidUpdate() {
        this.setRef();
    }
    render() {
        let queryParams = new URLSearchParams(window.location.search);
        let term = queryParams.get("categories");
        if(!term){
            term = "Frequently Asked Questions";
        }

        return (
            <div className="wrapper mb36">
                <Breadcrumbs pageTitle="FAQ"/>
                <ContentPanel
                    skeleton={<Skeleton type="MAIN_PANEL"/>}
                    errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
                    templateUrl="./content/learn/page-components/text-block/faq-heading.html"
                />
                <ContentAccordion
                    ref={this.contentAcc}
                    setRef={this.setRef}
                    isCategorized
                    jsonDataUrl="./content/learn/page-components/faq/faq.json"
                    selected={term}
                />
                <div className="mtm mbl">
                    <ToolsWidget/>
                </div>
            </div>
        );
    }
}
export default FAQ;



// WEBPACK FOOTER //
// ./src/pages/learn/FAQ.js